import { Component, HostListener, OnInit } from '@angular/core';
import { InviteCreation } from '../../../../core/models/inviteCreationModel';
import { UserRoles } from '../../../../core/models/enums/userRoles';
import { InviteService } from '../../../../core/services/api/invite.service';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { DialogModalComponent, IBasicModalComponentInstance, BasicModalOperationResult } from '../../../../shared/components/dialog-modal/dialog-modal.component';
import { Observable } from 'rxjs';
import { ComponentCanDeactivate } from '../../../../core/guards/pending-changes.guard';
import { DismissReason } from '../../../../shared/extensions/ng-active-modal/dismiss-reason';

@Component({
  selector: 'app-new-organization-invite',
  templateUrl: './new-organization-invite.component.html',
  styleUrls: ['./new-organization-invite.component.scss']
})
export class NewOrganizationInviteComponent implements ComponentCanDeactivate {
  showSpinner: boolean = false;
  submitting: boolean = false;
  hasSubmittedData: boolean = false;
  newUser: InviteCreation = new InviteCreation();
  userRoles = UserRoles;
  roles: string[];
  modalTitle: string;
  saveButtonTitle: string;

  constructor(private inviteService: InviteService,
    private route: ActivatedRoute,
    private router: Router,
    public activeModal: NgbActiveModal,
    private modalService: NgbModal,
    public translate: TranslateService) { }

  ngOnInit(): void {
    this.roles = Object.values(this.userRoles).filter(r => r === "Admin");
    this.newUser.role = this.userRoles.Admin;
  }

  @HostListener("window:beforeunload")
  canDeactivate(): Observable<boolean> | boolean {
    let hasPendingChanges = this.hasPendingChanges();
    let canLeave =
      !hasPendingChanges || (hasPendingChanges && this.hasSubmittedData);
    return canLeave;
  }

  closeModal() {
    if (this.hasPendingChanges()) {
      const modalRef = this.modalService.open(DialogModalComponent, {
        backdrop: "static",
        keyboard: false,
      });

      const modalInstance =
        modalRef.componentInstance as IBasicModalComponentInstance;
      modalInstance.title = this.translate.instant(
        "pendingChangesGuard.modalTitle"
      );
      modalInstance.type = BasicModalOperationResult.Warning;
      modalInstance.body = this.translate.instant(
        "pendingChangesGuard.modalBody"
      );
      modalInstance.buttons = [
        {
          text: this.translate.instant("pendingChangesGuard.cancel"),
          cssClass: "btn btn-outline-dark",
          handler: async (btn) => {
            modalInstance.closeModal();
          },
        },
        {
          closeModalOnClick: false,
          text: this.translate.instant("pendingChangesGuard.accept"),
          cssClass: "btn btn-success",
          handler: (btn) => {
            modalInstance.closeModal();
            this.activeModal.close(DismissReason.Cancelled);
          },
        },
      ];
    } else {
      this.activeModal.close(DismissReason.Cancelled);
    }
  }

  hasPendingChanges() {
    let hasPendingChanges =
      this.newUser.email ||
      this.newUser.firstName ||
      this.newUser.lastName ||
      this.newUser.fileNumber ||
      this.newUser.role;
    return hasPendingChanges;
  }

  async addNewUser() {
    try {
      this.hasSubmittedData = true;
      this.showSpinner = true;
      this.submitting = true;this.hasPendingChanges()
      this.newUser.isEmployee = false;
      this.newUser.isMainCompanyEmployee = false;
      await this.inviteService.addNewInvite(this.newUser);
      this.showSpinner = false;
      this.submitting = false;
      await this.showSuccessMessage();
      this.activeModal.close(DismissReason.Saved);
    } catch (error) {
      this.showSpinner = false;
      this.hasSubmittedData = false;
      this.submitting = false;
    }
  }

  async showSuccessMessage() {
    const modalRef = this.modalService.open(DialogModalComponent, {
      backdrop: "static",
      keyboard: false,
    });

    const modalInstance =
      modalRef.componentInstance as IBasicModalComponentInstance;
    modalInstance.title = this.translate.instant("usersModule.addedUser");
    modalInstance.body = this.translate.instant("usersModule.addedUser");
    modalInstance.type = BasicModalOperationResult.Success;

    await modalRef.result;
  }


}
